const initialState = {
    isLoading: false,
    isAuthenticated: false,
    user: null,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_USER":
            return { ...state, isLoading: true, errors: { err: {}, msg: [] } };
        case "LOGIN_SUCCESS":
            return { ...state, isLoading: false, isAuthenticated: true, user: action.payload };
        default:
            return state;
    }
};

export default authReducer;
